<nav class="navbar scrolled navbar-expand-lg" [dir]="lang == 'ar' ? 'rtl' : 'ltr'">
  <div class="d-flex gap-4">
    <img class="logo" [ngClass]="{ 'white-logo': whiteLogoPath }" *ngIf="whiteLogoPath" [src]="whiteLogoPath"
      alt="Company-logo" [routerLink]="['/' + lang + '/home']" />
    <img *ngIf="logoPath" [ngClass]="{ 'dark-logo': whiteLogoPath }" class="logo" [src]="logoPath"
      [routerLink]="['/' + lang + '/home']" alt="Company-logo" />

    <!-- Desktop Menu -->
    <ul id="navbarNav" class="tabs d-none d-md-flex m-0 gap-4 p-0 align-items-center" #header>
      <div class="d-block d-md-none close-icon">
        <i class="bi bi-x-circle fs-3" (click)="closeNavbar()"></i>
      </div>

      <!-- Desktop Nav Tabs -->
      <ng-container *ngIf="tabs">
        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
          *ngFor="let tab of tabs">
          <a class="nav-link" [routerLink]="'/' + lang + tab.route" (click)="closeNavbar()">
            {{ tab.name | translate }}
          </a>
        </li>
      </ng-container>

      <!-- Desktop: Language Switcher -->
      <li class="dropdown" *ngIf="selectedLanguage">
        <button class="btn lang-btn" type="button" id="languageDropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
          {{ selectedLanguage.name }}
          <img [src]="selectedLanguage.flag" alt="{{ selectedLanguage.name }}" />
        </button>
        <ul class="dropdown-menu" *ngIf="languages">
          <li *ngFor="let language of languages">
            <a class="dropdown-item" [href]="getNewURL(language.value)" (click)="selectLanguage(language.value)">
              <h6>{{ language.name }}</h6>
              <img [src]="language.flag" alt="{{ language.name }}" />
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>


  <!-- Mobile Menu -->
  <nav class="menu d-block d-md-none pointer menu-icon">
    <label class="menu-icon" for="toggle">&#9776;</label>
    <input hidden type="checkbox" id="toggle" />
    <div class="menu-content">
      <label class="d-block d-md-none close-icon" for="toggle">
        <i class="bi bi-x-circle fs-3"></i>
      </label>

      <!-- Mobile Nav Tabs -->
      <div *ngFor="let tab of tabs">
        <label for="toggle" class="nav-item w-100" routerLinkActive="active">
          <div class="nav-link p-0" [routerLink]="'/' + lang + tab.route">
            {{ tab.name | translate }}
          </div>
        </label>
      </div>

      <!-- Mobile: Login Button (not logged in) -->
      <div *ngIf="!(userInfo?.accessToken && userInfo?.userId)" class="d-flex justify-content-center mt-4">
        <label for="toggle">
          <a class="login-btn-link" [routerLink]="['/en/login']" (click)="closeNavbar()">
            {{ 'header_login' | translate }}
          </a>
        </label>
      </div>

      <!-- Mobile: Avatar (logged in) -->
      <div *ngIf="userInfo?.accessToken && userInfo?.userId" class="d-flex justify-content-center mt-4">
        <label for="toggle">
          <a class="profile-avatar-link" [routerLink]="['/' + lang + '/profile/myCourses']">
            <img *ngIf="userInfo?.profileImage; else mobileAvatarPlaceholder" [src]="userInfo.profileImage"
              alt="Profile" class="profile-avatar-img" />
            <ng-template #mobileAvatarPlaceholder>
              <div class="profile-avatar-placeholder">
                <i class="bi bi-person-fill"></i>
              </div>
            </ng-template>
          </a>
        </label>
      </div>

      <!-- Mobile: Language Switcher -->
      <li class="dropdown" *ngIf="selectedLanguage">
        <button class="btn lang-btn" type="button" id="languageDropdown" data-bs-toggle="dropdown"
          aria-expanded="false">
          {{ selectedLanguage.name }}
          <img [src]="selectedLanguage.flag" alt="{{ selectedLanguage.name }}" />
        </button>
        <ul class="dropdown-menu w-50 mx-auto" *ngIf="languages">
          <li *ngFor="let language of languages">
            <a class="dropdown-item d-flex" [href]="getNewURL(language.value)" (click)="selectLanguage(language.value)">
              <h6>{{ language.name }}</h6>
              <img [src]="language.flag" alt="{{ language.name }}" />
            </a>
          </li>
        </ul>
      </li>

    </div>
  </nav>


  <!-- Desktop: Avatar (logged in) — replaces login btn position -->
  <div class="nav-item d-none d-md-flex align-items-center" *ngIf="userInfo?.accessToken && userInfo?.userId">
    <a class="profile-avatar-link" [routerLink]="['/' + lang + '/profile/myCourses']" (click)="closeNavbar()">
      <img *ngIf="userInfo?.profileImage; else avatarPlaceholder" [src]="userInfo.profileImage" alt="Profile"
        class="profile-avatar-img" />
      <ng-template #avatarPlaceholder>
        <div class="profile-avatar-placeholder">
          <i class="bi bi-person-fill"></i>
        </div>
      </ng-template>
    </a>
  </div>

  <!-- Desktop: Login Button (not logged in) -->
  <div class="nav-item login-btn d-none d-md-block" *ngIf="!(userInfo?.accessToken && userInfo?.userId)">
    <a class="login-btn-link" [routerLink]="['/ar/login']" (click)="closeNavbar()">
      {{ 'header_login' | translate }}
    </a>
  </div>

</nav>